import { useOnValueChange } from '@calendly/hooks';
import { I18n } from '@calendly/i18n';
import { SimplePopup } from '@calendly/ui/components/popup';
import { BodyText } from '@calendly/ui/components/typography';
import { RadioField } from '@calendly/ui/form/radio-field';
import classNames from 'classnames';
import { useEffect, useState, forwardRef } from 'react';
import { snakeize } from 'services/string_utils';
const bodyWrapperCss = "b1d2crt9";
const BodyWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(bodyWrapperCss, props.className)} />;
});
const questionContainerCss = "qv5r96v";
const QuestionContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(questionContainerCss, props.className)} />;
});
export const ChangeLanguageModal = ({
  eventType,
  isOpen,
  onClose,
  updateEventType,
  isLoading,
  isSuccess
}) => {
  const {
    locale,
    available_locales: availableLocales
  } = snakeize(eventType);
  const [selectedLocale, setSelectedLocale] = useState(locale);
  const [languageChanged, setLanguageChanged] = useState(false);
  useEffect(() => {
    setSelectedLocale(locale);
  }, [locale]);
  useOnValueChange(isSuccess, () => {
    if (isSuccess && languageChanged) {
      setLanguageChanged(false);
      onClose();
    }
  });
  const onConfirmation = () => {
    if (selectedLocale === locale) {
      onClose();
    } else if (selectedLocale !== locale && !isLoading) {
      setLanguageChanged(true);
      updateEventType({
        eventType,
        attributes: {
          locale: selectedLocale
        }
      });
    }
  };
  return <SimplePopup isOpen={isOpen} onCancel={onClose} onClose={onClose} cancelLabel={I18n.t('publisher.action.cancel')} onConfirm={onConfirmation} confirmLabel={I18n.t('publisher.action.yes')} isLoading={isLoading} title={I18n.t('publisher.event_type_editor.header.settings.invitee_language.header')}>
      <BodyWrapper>
        <BodyText>
          {I18n.t('publisher.event_type_editor.header.settings.invitee_language.description')}
        </BodyText>
        <QuestionContainer>
          {availableLocales.map(thisLocale => <RadioField key={thisLocale.identifier} label={thisLocale.title} onChange={() => setSelectedLocale(thisLocale.identifier)} checked={thisLocale.identifier === selectedLocale} />)}
        </QuestionContainer>
        <BodyText>
          {I18n.t('publisher.event_type_editor.header.settings.invitee_language.translation_warning')}
        </BodyText>
      </BodyWrapper>
    </SimplePopup>;
};

require("./change_language_modal.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./change_language_modal.js");